/// <reference path="../Box.ts" />
namespace HA.Core.HTML {
    export class FacebookLoginBox extends Box {

        public hasRedirection() {
            return this.has("redirect");
        }

        public getRedirectionData() {
            return this.get("redirect");
        }

        /**
         *
         * @param data
         */
        protected initialize(data: { element: HTMLElement, onClick?: Function }) {
            super.initialize(data);
            const element = this.get("element");
            const redirect = {
                r: element.getAttribute("r"),
                id: element.getAttribute("rid"),
                haid: element.getAttribute("haid"),
            };
            if (redirect) {
                this.addToData("redirect", redirect);
            }
            this.addToData("button",
                new Form.Button({
                    element: element as HTMLElement,
                    onClick: data.onClick,
                }));
        }

        protected getVersion() {
            return this.get("button").getAttribute("version");
        }

        protected getAppId() {
            return this.get("button").getAttribute("appId");
        }
    }
}
